(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name pairingCompliments.controller:PairingComplimentsCtrl
   *
   * @description
   *
   */
  angular
    .module('pairingCompliments')
    .directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})
    .controller('PairingComplimentsCtrl', PairingComplimentsCtrl);

  function PairingComplimentsCtrl(EventManagerService,PairingComplimentsService,MessageService,PopupManager,applicationConstants,CommonMasterData) {
    var vm = this;
    vm.ctrlName = 'PairingComplimentsCtrl';

    vm.model = {
        	searchOnGoing : false,
        	searchPanelToggle:true,
        	initialSearchDone: false,
          editorMode:applicationConstants.EDITOR_STATUS.ADD,
      searchCriteria:{
        		modelNumber:null,
        		heavyFlight : "N",
            airportList:[],
             },
            selectedItem:{
        	  languages :[],
              crewTypeCodes:[],
            },
            requiredCrew:{
        	    crewTypeCode:null,
              crewTypeDescription:null,
              reqCrew:null,
            },
             masterLists:{
               acModelList:[],
               crewTypeCodes:[],
               airportList : [],
            	 languages : [],
               airCraftTypes:[],
             },
             airportsList:[],
             selectedAirportLangRequerment:null,
             isElasticLoadingVisible:false
     };

      EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);



    //load acModel list
    CommonMasterData.getAircraftTypeList(function (acModelLists) {
      console.log(acModelLists);
      vm.model.masterLists.acModelList = acModelLists;
      console.log(vm.model);
    }, function () {
    });

    //load crewTypes list
    CommonMasterData.getCrewTypeList(function (crewTypes) {
      angular.forEach(crewTypes, function (crewType) {
        crewType.reqCrew = 0;
        crewType.crewCompSeqId = null;
      });

      vm.model.masterLists.crewTypeCodes = crewTypes;

    }, function () {
    });

    CommonMasterData.getAirportList(function (airportList) {
      vm.model.masterLists.airportList = airportList;
    }, function () {
    });


      vm.clickOnSearch = function () {
            vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
            vm.model.initialSearchDone = false;
        };

        vm.searchByOptions = function(searchParams){
        	setDefault();
        	vm.searchPairingCompliments();
        }

        vm.searchPairingCompliments = function() {
        vm.model.pairingComplimentsList = [];
        vm.model.searchCriteria.startPosition = 1;
    		vm.model.initialSearchDone = true;
          searchPairingCompliments();
    };

        vm.selectPairingCompliments = function (selectedRowData) {
            vm.model.editorMode =  applicationConstants.EDITOR_STATUS.EDIT;
            vm.model.selectedPairingCompliments = PairingComplimentsService.formatGridSelectedRow(selectedRowData,vm.model.masterLists);
        };

        vm.addNewPairingCompliments = function () {
            vm.model.editorMode =  applicationConstants.EDITOR_STATUS.ADD;
            vm.model.selectedPairingCompliments = PairingComplimentsService.getNewPairingCompliments();
            vm.model.selectedAirportLangRequerment = null;
            vm.model.masterLists.airportCodeDisable=false;

            angular.forEach(vm.model.masterLists.crewTypeCodes, function (crewType) {
              crewType.reqCrew = 0;
              crewType.crewCompSeqId = null;
            });
        };

        vm.submitPairingCompliments = function(action, selectedItem) {
        	 vm.model.selectedPairingCompliments = selectedItem;
             if (action === applicationConstants.EDITOR_STATUS.DELETE){
            	 deletePairingComplimentsInfo(selectedItem);
             }else{
               savePairingComplimentsInfo()
             }
        }


        function searchPairingCompliments() {
          showLoader(true);
          var searchParams = vm.model.searchCriteria;
          PairingComplimentsService.searchPairingComplimentsGridData(vm.model.masterLists.crewTypeCodes,
            searchParams,
            function (pairingComplimentsDetails,startPosition) {
              console.log(pairingComplimentsDetails);
              updatePairingComplimentsList(pairingComplimentsDetails);
              updateGridSearchStartPosition(startPosition);
              vm.model.searchPanelToggle = false;
              showLoader(false);
              vm.model.searchOnGoing = false;
            },
            function (error) {
              MessageService.error(error);
              showLoader(false);
            }
          );
        }

        function getNextSetOfRecords() {
            vm.model.isElasticLoadingVisible = true;
            if(!vm.model.searchOnGoing){
            	vm.model.searchOnGoing = true;
            	searchPairingCompliments();
            }
        }

        function setDefault() {
        	vm.model.searchCriteria.pageSize = 100;
            vm.model.searchCriteria.startPosition = 1;
            vm.addNewPairingCompliments();
        }

        function updatePairingComplimentsList(pairingCompliments) {
            angular.forEach(pairingCompliments, function (pairingCompliment) {
                vm.model.pairingComplimentsList.push(pairingCompliment);
            });
            vm.model.isElasticLoadingVisible = false;
        }

        function showLoader(flag) {
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
                flag: flag,
                target: 'pairingCompliments',
                animationName: 'crewing-loader'
            });
        }

        function updateGridSearchStartPosition(startPosition) {
        	 vm.model.searchCriteria.startPosition = startPosition;
        }


        function savePairingComplimentsInfo() {
          PairingComplimentsService.savePairingCompliments(vm.model.masterLists.crewTypeCodes,
        		vm.model.selectedPairingCompliments,
                function (response) {
                    if(response.success){
                        MessageService.success('Successfully saved the record!');
                        vm.searchPairingCompliments();
                        vm.addNewPairingCompliments();
                    }else{
                        MessageService.error(response.errors[0]);
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function deletePairingComplimentsInfo(selectedItem){
          var param = {
              title: 'Confirmation',
              messages: ["Do you want to delete this record"],
              flags: selectedItem
          };
          PopupManager.openModal('CONFIRM_DIALOG', param, confirmDeleteDialog);
        }


        function confirmDeleteDialog(pass) {
            if(pass==='YES'){
              PairingComplimentsService.deletePairingComplimentsInfo(vm.model.selectedPairingCompliments,
                    function (response) {
                        MessageService.success('Successfully deleted the record!');
                        vm.searchPairingCompliments();
                        vm.addNewPairingCompliments();
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                );
            }
        }

    PairingComplimentsService.searchLanugages(
       		 function(langCatList){
             angular.forEach(langCatList, function (lang) {
               lang.langCompSeqId = null;
             });

             vm.model.masterLists.languages= langCatList;
       		 },
       		 function(error){
       			 MessageService.error(error);
       		 }
       );

    function init() {

      CommonMasterData.getAircraftModels(function (airCraftList) {
        vm.model.masterLists.airCraftTypes = airCraftList;
      }, function (error) {

      });

    }
    init();


      setDefault();


  }
}());
